import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from "vuex";
import FormEditPage from "../../components/FormEditPage";
import CardItem from "@/pages/designCategory/components/CardItem";
import Title from "@/pages/designCategory/components/Title";
import ColorPicker from "@/pages/designCategory/components/ColorPicker";
import FileUpload from "@/pages/designCategory/components/FileUpload";
export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    Title: Title,
    ColorPicker: ColorPicker,
    FileUpload: FileUpload
  },
  data: function data() {
    return {
      show: false,
      form: this.$form.createForm(this),
      rightIndex: 0 // 右侧选择的index
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    rightCom: function rightCom(state) {
      return state.designCategory.select_right_com;
    },
    rightId: function rightId(state) {
      return state.designCategory.select_right_id;
    }
  })), {}, {
    list: function list() {
      if (!this.rightCom.img) return [];
      return ['' + this.rightCom.img];
    }
  }),
  watch: {
    rightId: function rightId() {
      // 判断是不是当前选中的aside 是就显示
      if (!this.rightId) {
        this.show = false;
        return;
      }
      var _this$rightId$split = this.rightId.split("-"),
        _this$rightId$split2 = _slicedToArray(_this$rightId$split, 2),
        asideId = _this$rightId$split2[0],
        rightId = _this$rightId$split2[1];
      // asideId = parseInt(asideId)
      // rightId = parseInt(rightId)

      if (this.value.id !== asideId) return;
      this.show = true;
    }
  },
  methods: {
    handleImg: function handleImg() {
      this.rightCom.img = '';
    },
    handleImgSuccess: function handleImgSuccess(val) {
      this.rightCom.img = val;
    }
  }
};